import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface CartOrderGroupEntityParams {
  orderGroupId: number;
  type?: string;
}
export class CartOrderGroupEntity extends BaseEntityClass {
  orderGroupId: number;
  constructor(params: CartOrderGroupEntityParams) {
    super();
    this.type = params.type || "cart_order_group_event";
    this.entity_version = 2;
    this.orderGroupId = params.orderGroupId;
  }
}
